import { getPath } from '@/router/common'

const baseUrl = {
  title: '运单自定义',
  path: 'BillingCustom'
}

export default [
  {
    path: getPath('BillingTemplateList', baseUrl),
    name: 'BillingTemplateList',
    component: () =>
      import(
        /* webpackChunkName: "BillingTemplateList" */ '@/views/billingCustom/billingTemplateList/index.vue'
      ),
    meta: {
      title: '运单自定义'
    }
  },
  {
    path: getPath('BillingSettings', baseUrl),
    name: 'BillingSettings',
    component: () => import(/* webpackChunkName: "BillingSettings" */ '@/views/billingCustom/billingSettings/index.vue'),
    meta: {
      title: '运单自定义新增'
    }
  },
  {
    path: getPath('BillingView', baseUrl),
    name: 'BillingView',
    component: () => import(/* webpackChunkName: "BillingView" */ '@/views/billingCustom/billingView/index.vue'),
    meta: {
      title: '运单自定义预览'
    }
  },
  {
    path: getPath('BillingNew', baseUrl),
    name: 'BillingCustom_BillingNew',
    component: () => import(/* webpackChunkName: "BillingCustom_BillingNew" */ '@/views/billingCustom/billingNew/index.vue'),
    meta: {
      title: '新开单页'
    }
  }
]
